import ReelerBadge from "./ReelerBadge"

export default ReelerBadge
